(function($){
	
	const
	mobile_menu = $('.site-header__mobile-nav'),
	menu_icon = $('.site-header__menu-icon'),
	header = $('.site-header');
	
	let admin_offset = ($('body').hasClass('admin-bar')) ? 'site-header__mobile-nav--is-admin': '';
	
	mobile_menu.addClass(admin_offset);
	
	menu_icon.click(menu_init);
	
	function menu_init() {
		header.toggleClass('site-header__mobile-menu--is-out');
		$('html, body').toggleClass('mobile-menu--is-out');
		mobile_menu.toggleClass('site-header__mobile-nav--is-out');
		set_aria_hidden($(this));
		set_aria_hidden(mobile_menu);
	}
	
	function set_aria_hidden(selector) {
		if ( 'false' === $(selector).attr('aria-expanded') ) {
			$(selector).attr('aria-expanded', 'true');
		} else {
			$(selector).attr('aria-expanded', 'false');
		}
	}
	
})(jQuery);